export const admissionsOfficeHeaderSelectConst = [
  {
    id: "admission-letter",
    title: "Admission letter",
    mass: [{ name: "Ukraine" }, { name: "Malta" }, { name: "Poland" }],
  },
  {
    id: "admission-letter-2",
    title: "Admission letter 2",
    mass: [{ name: "Ukraine 2" }, { name: "Malta 2" }, { name: "Poland 2" }],
  },
  {
    id: "admission-letter-3",
    title: "Admission letter 3",
    mass: [{ name: "Ukraine 3" }, { name: "Malta 3" }, { name: "Poland 3" }],
  },
];

export const admissionsOfficeHeaderTabsConst = [
  {
    id: "ukraine",
    title: "Ukraine",
    mass: [
      { name: "Admission letter", slug: "admission", lang: "en" },
      { name: "Invoice letter", slug: "invoice", lang: "en" },
      { name: "Payment confirmation letter", slug: "payment", lang: "en" },
      { name: "Letter of acknowledgement", slug: "acknowledgement", lang: "en" },
      { name: "Request Letter", slug: "request", lang: "en" },
      { name: "Inquiry", slug: "inquiry", lang: "en" },
    ],
  },
  {
    id: "malta",
    title: "Malta",
    mass: [
      { name: "Admission letter", slug: "admission", lang: "en" },
      { name: "Admission letter FR", slug: "admission", lang: "fr" },
      { name: "Admission letter DE", slug: "admission", lang: "de" },
      { name: "Admission letter UZB", slug: "admission", lang: "uzb" },
      { name: "Student Letter", slug: "student", lang: "en" },
      { name: "Invoice letter", slug: "invoice", lang: "en" },
      { name: "Invoice letter FR", slug: "invoice", lang: "fr" },
      { name: "Invoice letter DE", slug: "invoice", lang: "de" },
      { name: "Invoice letter UZB", slug: "invoice", lang: "uzb" },
      { name: "Payment confirmation letter", slug: "payment", lang: "en" },
      { name: "Certificates", slug: "certificates", lang: "en" },
      { name: "Letter of acknowledgement", slug: "acknowledgement", lang: "en" },
    ],
  },
  {
    id: "poland",
    title: "Poland",
    mass: [
      { name: "Admission letter", slug: "admission", lang: "en" },
      { name: "Invoice letter", slug: "invoice", lang: "en" },
      { name: "Payment confirmation letter", slug: "payment", lang: "en" },
      { name: "Letter of acknowledgement", slug: "acknowledgement", lang: "en" },
    ],
  },
  {
    id: "switzerland",
    title: "Switzerland",
    mass: [
      { name: "Admission letter", slug: "admission", lang: "en" },
      { name: "Invoice letter", slug: "invoice", lang: "en" },
      { name: "Student Letter", slug: "student", lang: "en" },
      { name: "Degree Documents", slug: "degree-documents", lang: "en" },
    ],
  },
];

export const admissionOfficeWhoseDoc = [
  "FR IEU Malte",
  "Edward Wilson",
  "Zimbabwe IEU Malta",
  "Univer Malta campus",
  "Cristy Bishop",
  "Victoria Smith",
  "Isaac Davis",
  "Olivia IEU",
  "Maryna Koval",
  "Karina Pinchuk",
  "Zoia Kozachenko",
  "RUSVUZ st",
  "RUSVUZ ag",
  "RECAS st",
  "RECAS ag",
  "REC st",
  "REC ag",
  "REG st",
  "REG ag",
  "EDUGAIN ag",
  "EDUGAIN st",
  "IEU Pl ag",
  "IEU Malta st",
  "IEU Pl st",
  "Anna Ivchenko",
  "IEU UA st",
  "IEU UA ag",
  "UEG",
  "IEU Pakistan",
  "12Consultants",
  "UES",
  "Jasper Jones",
];
